import { useNavigate } from 'react-router-dom';

import type { RBACUser } from '../../../types';

import Autocomplete from './UserAutocomplete';

type UserSelectProps = {
  users: RBACUser[] | undefined;
  selectedId?: string;
  // Controlled by the header switch group (routes/users.tsx); when false, disabled
  // accounts are filtered out of the search results.
  showDisabled?: boolean;
};

export default function UserSelect({ users, selectedId, showDisabled = false }: UserSelectProps) {
  // Navigate to user page on select
  const navigate = useNavigate();
  const setUser = (user: RBACUser) => {
    navigate(`/users/${user.id}`);
  };

  if (!users) {
    return <div>No users to display</div>;
  }
  // filter out users without displayName, id, and filter out disabled users if showDisabled is false
  const userList = users.filter(
    (user) => user.displayName && user.id && (showDisabled || user.accountEnabled)
  );

  return (
    <div>
      <div className="font-bold pb-2">Search for user/UPN:</div>
      <Autocomplete
        items={userList}
        onSelect={setUser}
        selectedId={selectedId}
        onClear={() => navigate('/users')}
      />
    </div>
  );
}
